<div class="right" *ngIf="app.isDesktop">
    <div class="logoCenter">
        <img src="../../assets/img/logo.png">
    </div>
</div>
